import React, { useState } from "react";
import { Modal } from "@mui/material";
import BasicButton from "@/UI/BasicButton";
import modalStyles from "@/Theme/modalsElements.module.scss";
import { ImportOrderModal } from "./import-order-modal";

export const ImportOrderButton = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleOpenImportModal = () => {
    setModalIsOpen(true);
  };

  const handleCloseImportModal = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      <BasicButton
        onClick={handleOpenImportModal}
        size="md"
        text="Import file"
        variant="blue"
      />
      <Modal
        open={modalIsOpen}
        onClose={handleCloseImportModal}
        className={modalStyles.modal}
      >
        <ImportOrderModal onClose={handleCloseImportModal} />
      </Modal>
    </>
  );
};
